import styled from 'styled-components';
import { Grid, media } from '@simplywallst/ui-core';

import { Row } from '@simplywallst/ui-core';

export const Container = styled(Row)`
  position: relative;
  width: 100%;
  background: ${({ theme }) => theme.color.charcoal};
  padding: ${({ theme }) => `${theme.x3spacePx}px ${theme.x2spacePx}px`};
  ${media.lgUp`
    ${({ minHeight }) => minHeight && `min-height: 320px;`}
    padding: ${({ theme }) => theme.x5spacePx}px ${({ theme }) =>
      theme.x4spacePx}px;
  `}
`;

export const Gradient = styled('div')`
  position: absolute;
  left: 0;
  top: 0;
  width: 101%;
  height: 100%;
  background: ${({ theme }) => theme.color.charcoalRGBA(0.8)};
  mix-blend-mode: normal;
  z-index: 1;
`;

export const Content = styled('section')`
  position: relative;
  z-index: 2;
  width: 100%;
`;

export const CoverContainer = styled('div')`
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  ${media.mdDown`
    border-radius: 0;
  `}
`;

export const CoverImage = styled('img')`
  object-fit: cover;
  height: 100%;
  width: 100%;
`;

export const BreadcrumbContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.x2space}rem;
  ${media.lgUp`
    margin-bottom: ${({ theme }) => theme.x3space}rem;
  `}
`;

export const DeprecatedTitle = styled.h1`
  ${({ theme }) => theme.typography.heroStrong}
  margin: 0;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const MetaContainer = styled.div`
  padding-top: ${({ theme }) => theme.x2space}rem;
`;

export const Filter = styled(Grid)`
  ${media.xsDown`
    white-space: nowrap;
    overflow-x: auto;
  `}
`;
